export const blockIconsAudioandvideoPlayCircleNew = (
	<span className='material-symbols-outlined'>play_circle</span>
);
